import { BaseOauthClient } from "./base";

export class HubspotOauthClient extends BaseOauthClient {
    provider = "hubspot";
    baseUrl = "https://app.hubspot.com";
    authorizationEndpoint = '/oauth/authorize';
    tokenEndpoint = "https://api.hubapi.com/oauth/v1/token";
    authenticationMethod = "client_secret_post";

    clientId = process.env.HUBSPOT_CLIENT_ID || "";
    clientSecret = process.env.HUBSPOT_CLIENT_SECRET || "";
    extraParams = {
        optional_scope: [
            "crm.lists.read",
            "crm.objects.appointments.read",
            "crm.objects.carts.read",
            "crm.objects.commercepayments.read",
            "crm.objects.companies.read",
            "crm.objects.contacts.read", "crm.objects.courses.read", "crm.objects.custom.read", "crm.objects.deals.read", "crm.objects.feedback_submissions.read", "crm.objects.goals.read", "crm.objects.invoices.read", "crm.objects.leads.read", "crm.objects.line_items.read", "crm.objects.listings.read", "crm.objects.marketing_events.read", "crm.objects.orders.read", "crm.objects.owners.read", "crm.objects.partner-clients.read", "crm.objects.quotes.read", "crm.objects.services.read", "crm.objects.subscriptions.read", "crm.objects.users.read", "crm.pipelines.orders.read", "crm.schemas.appointments.read", "crm.schemas.carts.read", "crm.schemas.commercepayments.read", "crm.schemas.companies.read", "crm.schemas.contacts.read", "crm.schemas.courses.read", "crm.schemas.custom.read", "crm.schemas.deals.read", "crm.schemas.invoices.read", "crm.schemas.line_items.read", "crm.schemas.listings.read", "crm.schemas.orders.read", "crm.schemas.quotes.read", "crm.schemas.services.read", "crm.schemas.subscriptions.read"
        ].join(" ")
    };
    scopes = [
        "oauth"
    ];

    constructor(team: string, supabaseClient: any, id?: string) {
        super(team, supabaseClient, id);
        this.initializeOauthClient();
    }

    async getRecords() {
        return [];
    }
}

